import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class PreallocationWithoutRelationsDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.memo = initializer.memo;
        this.managerId = initializer.managerId;
    }
}
